var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"new-delagation-page"}},[_c('DelegationForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }